import { getSelectOptions } from './getSelectOptions.function';
import { TNomenclature } from '@/types';

export const getTitleEnumValue = <TValue = string>(type: TNomenclature, value: string | number) => {

  const selectOptions = getSelectOptions(type);

  const result = selectOptions.find(l => l.value === value)?.title as TValue;

  return result;

};
